import React from "react";

export default function Link (){
    const svg = `
<svg width="23px" height="24px" viewBox="0 0 23 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group" fill="#020031" fill-rule="nonzero">
            <path d="M2,21.5 L2,4.5 L6.8,4.5 L6.8,2.5 L1,2.5 C0.4,2.5 0,2.9 0,3.5 L0,22.5 C0,23.1 0.4,23.5 1,23.5 L20,23.5 C20.6,23.5 21,23.1 21,22.5 L21,16.7 L19,16.7 L19,21.5 L2,21.5 Z" id="Path"></path>
            <polygon id="Path" points="19.1 2.2 9.7 11.6 11.1 13 20.6 3.5 20.6 6.7 22.6 6.7 22.6 0 15.9 0 15.9 2 19.1 2"></polygon>
        </g>
    </g>
</svg>`;
    return (
        <i className={'icon'} dangerouslySetInnerHTML={{__html: svg}}/>
    )
}
